import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useCreateDeliveryCollectionMutation } from "store/services/deliveryCollectionApi";
import DeliveryCollectionByShipmentForm from "./DeliveryCollectionComponents/DeliveryCollectionByShipmentForm";



const DeliveryCollectionShipmentCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Delivery Collections", path: "/app/crm/delivery-collection/list" },
    { title: "New Delivery Collection" }
  ];

  const [createDeliveryCollection, { isLoading: creatingDeliveryCollection }] =
    useCreateDeliveryCollectionMutation();

  const handleAddDeliveryCollection = async (data) => {
    try {
      const { data: { _id } } = await createDeliveryCollection(data).unwrap();
      toast.success("Delivery Collection Created!");
      navigate(`/app/crm/delivery-collection/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Delivery Collection!"
      );
    }
  };

  useAppMeta("New Delivery Collection");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingDeliveryCollection}>
      <BreadcrumbLayout.Paper>
        <DeliveryCollectionByShipmentForm
          isBusy={creatingDeliveryCollection}
          onSubmit={handleAddDeliveryCollection}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryCollectionShipmentCreateScreen;